"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchImpl = void 0;
const variant_1 = require("./variant");
const precepts_1 = require("./precepts");
function matchImpl(key) {
    // curryable wrapper around match.
    const prematch = (_) => (handler) => (instance) => match(instance, handler);
    function match(...args) {
        var _a, _b;
        if (args.length === 1) {
            // inline match
            const [handler] = args;
            return (instance) => match(instance, handler);
        }
        else if (args.length === 2) {
            // regular match
            const [instanceOrTypeOrCreator, handlerParam] = args;
            const instanceOrCreator = typeof instanceOrTypeOrCreator === 'string'
                ? ofLiteral(instanceOrTypeOrCreator)
                : instanceOrTypeOrCreator;
            // unpack handler from function if necessary.
            const handler = typeof handlerParam === 'function'
                ? handlerParam(instanceOrCreator)
                : handlerParam;
            const tType = instanceOrCreator == undefined
                ? undefined
                : (0, variant_1.isVariantCreator)(instanceOrCreator)
                    ? instanceOrCreator.output.type
                    : instanceOrCreator[key];
            if (instanceOrCreator != undefined && tType !== undefined && tType in handler) {
                return (_a = handler[tType]) === null || _a === void 0 ? void 0 : _a.call(handler, instanceOrCreator);
            }
            else if (precepts_1.DEFAULT_KEY in handler) {
                return (_b = handler[precepts_1.DEFAULT_KEY]) === null || _b === void 0 ? void 0 : _b.call(handler, instanceOrCreator);
            }
        }
    }
    const partial = (h) => () => h;
    const onLiteral = ofLiteral;
    function ofLiteral(instance) {
        return {
            [key]: instance,
        };
    }
    function lookup(handler) {
        const handlerWithFuncs = Object.keys(handler).reduce((acc, cur) => {
            return Object.assign(Object.assign({}, acc), { [cur]: () => handler[cur] });
        }, {});
        return _ => handlerWithFuncs;
    }
    function otherwise(branches, elseFunc) {
        return _ => (Object.assign(Object.assign({}, branches), { default: elseFunc }));
    }
    function withFallback(handler, fallback) {
        return _ => (Object.assign(Object.assign({}, handler), { default: fallback }));
    }
    return { match, ofLiteral, onLiteral, otherwise, partial, prematch, lookup, withFallback };
}
exports.matchImpl = matchImpl;
